export default {"src":"/_next/static/media/note-bright-blue.ddb4f683.svg","height":8,"width":44,"blurWidth":0,"blurHeight":0};